import React from 'react';
import { Box, Typography } from '@mui/material';

interface LanCardComponentProps {
  percentage?: number;
  unit?: string;
  leftCaption: string;
  rightCaption?: string;
  customDisplayText?: string;
}

const LanCardComponent: React.FC<LanCardComponentProps> = ({
  percentage,
  unit = '',
  leftCaption,
  rightCaption,
  customDisplayText,
}) => {
  const safePercentage = Math.min(Math.max(percentage ?? 0, 0), 100);


  return (
    <Box
      sx={{
        backgroundColor: '#F9F9F9',
        borderRadius: '10px',
        padding: '7px 11px',
        width: '200px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      {/* Top Captions */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontWeight: 600,
            fontSize: '14px',
            color: '#45464E',
          }}
        >
          {leftCaption}
        </Typography>

        {rightCaption && (
          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontWeight: 500,
              fontSize: '15px',
              letterSpacing: '0.22px',
              color: '#45464E',
              textAlign: 'right',
            }}
          >
            {rightCaption}
          </Typography>
        )}
      </Box>

      {/* Progress Bar */}
      {typeof percentage === 'number' && (
        <Box
          sx={{
            height: '5px',
            backgroundColor: '#D6DAFA',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              width: `${Math.min(Math.max(percentage, 0), 100)}%`,
              height: '100%',
              background: '#5D739E',
              transition: 'width 0.3s ease-in-out',
            }}
          />
        </Box>
      )}

      {/* Bottom Display */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontWeight: 500,
            fontSize: '24px',
            letterSpacing: '0.22px',
            color: '#45464E',
            textAlign: 'right',
          }}
        >
          {customDisplayText}
          {unit && (
            <Typography
              component="span"
              sx={{
                fontFamily: 'Roboto',
                fontWeight: 500,
                fontSize: '18px',
                letterSpacing: '0.22px',
                color: '#45464E',
              }}
            >
              &nbsp;{unit}
            </Typography>
          )}
        </Typography>
      </Box>
    </Box>
  );
};

export default LanCardComponent;
